import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {AuthContext} from "../../Infrastructure/provider/AuthProvider";
import {publicationAPI} from "../../Redux/services/PublicationService";
import {useNavigate} from "react-router-dom";

const CreatePost = () => {


    const { register, handleSubmit, formState: { errors }, watch } = useForm();
    const { user } = useContext(AuthContext);
    const [createPost] = publicationAPI.useCreatePublicationMutation()
    const navigate = useNavigate();
    const putPost = (data: any) => {

        const formData = new FormData();

        formData.append("title", data.title);
        formData.append("content", data.content);
        formData.append("category_id", data.category);
        formData.append("user_id", user.id);

        // если есть файлы — добавляем
        if (data.files && data.files.length > 0) {
            Array.from(data.files).forEach((file: any) => {
                formData.append("files[]", file);
            });
        }

        createPost(formData); // важно: отправлять именно FormData!
        navigate('/category');
    };

    return (
        <div className="flex flex-col h-[75vh] overflow-y-auto">
            <form
                onSubmit={handleSubmit(putPost)}
                className="bg-white border border-gray-300 rounded-md shadow-sm p-4 flex flex-col gap-4 flex-1"
            >
                {/* Категория */}
                <div className="flex flex-col">
                    <div className="flex items-center gap-3">
                        <label
                            htmlFor="category"
                            className="text-blue-800 font-medium"
                        >
                            Категорiя:
                        </label>

                        <select
                            id="category"
                            {...register("category", { required: "Оберiть категорiю" })}
                            className={`border rounded-sm px-3 py-2 w-60 text-blue-800 focus:outline-none focus:ring-2 ${
                                errors.category
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-blue-300"
                            }`}
                        >
                            <option value="">-- Оберiть категорiю --</option>
                            {user.accessible_categories.map((item: any) => (
                                <option key={item.id} value={item.id}>
                                    {item.title}
                                </option>
                            ))}
                        </select>
                    </div>

                    {errors.category && (
                        <p className="text-red-500 text-xs ml-[8.2rem] mt-1">
                            {errors.category.message as string}
                        </p>
                    )}
                </div>

                {/* Заголовок */}
                <div className="flex items-center gap-2">
                    <label
                        htmlFor="title"
                        className="text-blue-800 font-medium mb-1"
                    >
                        Заголовок:
                    </label>
                    <input
                        id="title"
                        type="text"
                        {...register("title", { required: "Введите заголовок" })}
                        placeholder="Enter publication title..."
                        className={`border w-full rounded-sm px-3 py-2 text-blue-800 focus:outline-none focus:ring-2 ${
                            errors.title
                                ? "border-red-500 focus:ring-red-300"
                                : "border-gray-300 focus:ring-blue-300"
                        }`}
                    />
                    {errors.title && (
                        <p className="text-red-500 text-xs mt-1">
                            {errors.title.message as string}
                        </p>
                    )}
                </div>

                {/* Файлы */}
                <div className="flex items-center gap-2">
                    <label
                        htmlFor="files"
                        className="text-blue-800 font-medium mb-1"
                    >
                        Файли (не обов'язково):
                    </label>
                    <input
                        id="files"
                        type="file"
                        multiple
                        {...register("files")}
                        className="border border-gray-300 rounded-sm px-2 py-2 text-blue-800 cursor-pointer
                           file:bg-blue-600 file:text-white file:border-none file:px-3
                           file:py-1 file:mr-3 file:rounded-md file:cursor-pointer"
                    />

                    {/* Список выбранных файлов */}
                        {watch("files") && watch("files")!.length > 0 && (
                        <ul className="list-disc ml-5 mt-2 text-sm text-blue-800">
                            {Array.from(watch("files") as FileList).map((file: File, index: number) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Контент */}
                <div className="flex flex-col flex-1">
            <textarea
                id="content"
                {...register("content", { required: "Введите текст публикации" })}
                placeholder="Enter publication text..."
                className={`border rounded-md p-3 w-full h-[60vh] resize-none text-blue-800 focus:outline-none focus:ring-2 ${
                    errors.content
                        ? "border-red-500 focus:ring-red-300"
                        : "border-gray-300 focus:ring-blue-300"
                }`}
            />
                    {errors.content && (
                        <p className="text-red-500 text-xs mt-1">
                            {errors.content.message as string}
                        </p>
                    )}
                </div>

                {/* Кнопка */}
                <div className="flex justify-start mt-3">
                    <button
                        type="submit"
                        className="bg-[#4573c4] text-white px-6 py-1 rounded-md shadow-md text-sm hover:bg-[#365da3] transition"
                    >
                        Зберегти
                    </button>
                </div>
            </form>
        </div>


    );
};

export default CreatePost;
